import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { handleActions } from 'redux-actions';
import { fetchPageSuccess } from '../actions/page';
const defaultState = {};
export default handleActions({
    [fetchPageSuccess.toString()]: (state, action)=>_object_spread({}, state, action.payload)
}, defaultState);

//# sourceMappingURL=page.js.map